import { ConfirmationModal } from "./ConfirmationModal";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
}

export const ResetForecastModal = (props: Props) => {

  const getBody = () => {
    return (
      <>
        <p>Are you sure you want to start again?</p>
        <p>Your changes will be lost!</p>
      </>
    );
  };

  return (
    <ConfirmationModal
      {...props}
      confirmLabel="Yes"
      body={getBody()}
      header="Start a new forecast"
    />
  );
};
